export default __webpack_public_path__ + "static/media/ic_notification_chat.304fccff.svg";